import { Fragment } from 'react'
import { Typography, TypographyProps } from '@mui/material'
import { formatString } from '../util/formatString'

const ZText = (props: TypographyProps) => {
  const { children, ...rest } = props

  const formatChildren = () => {
    if (typeof children === 'string') {
      return formatString(children)
    }

    // The learn-more-link path passes a reactStringReplace array mixing plain
    // strings (which may carry *bold*/~italic~/_underline_ markup) and elements
    // (e.g. <Link>). Run formatString on the string segments so both render.
    if (Array.isArray(children)) {
      return children.map((child, index) =>
        typeof child === 'string' ? (
          <Fragment key={index}>{formatString(child)}</Fragment>
        ) : (
          child
        ),
      )
    }

    return children
  }

  return (
    <Typography whiteSpace="pre-wrap" {...rest}>
      {formatChildren()}
    </Typography>
  )
}

export default ZText
